// extracted by mini-css-extract-plugin
module.exports = {"dashboardNav":"DashboardNav_dashboardNav__1_XkG","hide":"DashboardNav_hide__14tfC"};